import PluginsPage from './PluginsPage'

export default PluginsPage
